import { borderRadius } from 'fitify-ui/src/theme/generated/theme-variables'
import { themeColors as figmaThemeColors } from 'fitify-ui-onboarding/src/theme/generated/theme-colors'
import {
  dynamicSizes,
  themeFonts,
  themeSizes,
} from 'fitify-ui-onboarding/src/theme/variables'
import {
  ColorTheme,
  FigmaColorTheme,
  type Theme,
} from 'fitify-ui-onboarding/src/types/theme'
import { useGrowthBook } from 'fitify-ui-onboarding/src/utils/growthbook/generated'
import { useMemo } from 'react'

import {
  resolveF01ThemeVariant,
  resolveM01ThemeVariant,
} from 'components/GenderFunnel/Layout/Layout.Utils'
import { useFunnel } from 'hooks/useFunnel'
import { Funnel } from 'types/state'
import { useDataState } from 'utils/state'

export const useDefaultTheme = () => {
  return useMemo(
    (): Theme => ({
      colors: figmaThemeColors[FigmaColorTheme.BlueLight],
      dynamicSizes,
      fonts: themeFonts.genderSpecificFunnel,
      isDarkTheme: false,
      radius: borderRadius['Large'],
      sizes: themeSizes.genderSpecificFunnel,
      type: ColorTheme.BlueLight,
    }),
    []
  )
}

export const useLayoutTheme = () => {
  const growthBook = useGrowthBook()
  const funnel = useFunnel()
  const { data } = useDataState()
  const defaultTheme = useDefaultTheme()

  return useMemo((): Theme => {
    switch (funnel) {
      case Funnel.CHF01:
      case Funnel.CHM01:
        return {
          colors: figmaThemeColors[FigmaColorTheme.EmeraldGreenLight],
          dynamicSizes,
          fonts: themeFonts.genderSpecificFunnel,
          isDarkTheme: false,
          radius: borderRadius['Large'],
          sizes: themeSizes.genderSpecificFunnel,
          type: ColorTheme.EmeraldGreenLight,
        }
      case Funnel.M01: {
        return {
          ...resolveM01ThemeVariant(growthBook, data.common.onboardingVariant),
          dynamicSizes,
          fonts: themeFonts.genderSpecificFunnel,
          radius: borderRadius['Large'],
          sizes: themeSizes.genderSpecificFunnel,
        }
      }
      case Funnel.F01:
      case Funnel.HOPIF01:
      case Funnel.WALLPIF01: {
        return {
          ...resolveF01ThemeVariant(growthBook, data.common.onboardingVariant),
          dynamicSizes,
          fonts: themeFonts.genderSpecificFunnel,
          isDarkTheme: false,
          radius: borderRadius['Large'],
          sizes: themeSizes.genderSpecificFunnel,
        }
      }
      case Funnel.TCHM01:
        return {
          colors: figmaThemeColors[FigmaColorTheme.SoftPeriwinkleLight],
          dynamicSizes,
          fonts: themeFonts.genderSpecificFunnel,
          isDarkTheme: false,
          radius: borderRadius['Large'],
          sizes: themeSizes.genderSpecificFunnel,
          type: ColorTheme.SoftPeriwinkleLight,
        }
      case Funnel.MILICAF01:
      case Funnel.MILICAM01:
        return {
          colors: figmaThemeColors[FigmaColorTheme.SandMilitaryDark],
          dynamicSizes,
          fonts: themeFonts.genderSpecificFunnel,
          isDarkTheme: true,
          radius: borderRadius['Large'],
          sizes: themeSizes.genderSpecificFunnel,
          type: ColorTheme.SandMilitaryDark,
        }
      default:
        return defaultTheme
    }
  }, [data.common.onboardingVariant, defaultTheme, funnel, growthBook])
}
